import { ThemeColors } from '~/themes/colors'

interface ListViewColors {
  ListItem: {
    Title: {
      SearchHighlight: ThemeColors
    }
    DateTime: { FontColor: ThemeColors }
  }
}

export const listViewColors: ListViewColors = {
  ListItem: {
    Title: {
      SearchHighlight: {
        default: 'mango.highlight',
      },
    },
    DateTime: {
      FontColor: {
        default: 'gray.800',
      },
    },
  },
}
